<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <router-link to="/insights/podcast">
      <button
        class="flex items-center sm-fsize14 text-white bg-primary py-2 px-4 rounded-md mb-6"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class=""
          svgClasses="w-4 h-4 mr-1"
        ></feather-icon>
        Go Back
      </button></router-link
    >
    <div
      class="text-center sm-wfull mx-auto lg:flex md:flex gap-8 items-center"
    >
      <div class="rounded-xl lg:w-1/2 md:w-1/2 w-full">
        <img
          class="lg:h-72 h-64 w-full rounded-xl mx-auto object-contain"
          :src="`${$imageURL}/${getAllCategory.result[0].image}`"
          alt="img"
        />
        <!-- src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg" -->
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <p class="fsize40 md-fsize28 sm-fsize18 clr-black font-semibold pb-2">
          <!-- Journey Of Compassion -->

          {{ getAllCategory.result[0].name }}
        </p>
        <!-- <p class="fsize20 sm-fsize14">
        
          {{ getAllCategory.result[0].description }}
        </p> -->
        <p
          class="fsize20 sm-fsize14 text-justify"
          v-html="getAllCategory.result[0].description"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  metaInfo() {
    return {
      title: this.getAllCategory.result[0].metaTitle,
      meta: [
        {
          name: "keyword",
          content: this.getAllCategory.result[0].metaKeyword,
        },
        {
          name: "description",
          content: this.getAllCategory.result[0].metaDesc,
        },
        {
          rel: "canonical",
          href: this.getAllCategory.result[0].metaCanonicalTag,
        },
      ],
    };
  },
  computed: {
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    handleClick(val) {
      this.$router.push({ name: val });
    },
  },
  async mounted() {
    try {
      // let data = await this.$store.dispatch("podcast/getall_category", {
      //   cid: this.$route.query.cid,
      // });
    } catch (error) {}
  },
};
</script>
